import { Injectable, computed, inject, signal } from '@angular/core';
import { BaseService } from '../base.service';
import { LearnerReportsStore } from './learner-reports/learner-reports.store';
import { QuarterlyReportsStore } from './quarterly-reports/quarterly-reports.store';


@Injectable({
  providedIn: 'root',
})
export class ReportsService extends BaseService {
  learnerReportsStore = inject(LearnerReportsStore);
  quarterlyReportsStore = inject(QuarterlyReportsStore);

  //////////////////////////
  //    Learner Reports   //
  //////////////////////////

  getLearnerMetrics(params: any) {
    this.learnerReportsStore.setLearnerMetricsLoading(true);

    return this.http.get('Report/learner-metrics', { params: params }).subscribe({
      next: (learnerMetrics: any) => {
        this.learnerReportsStore.setLearnerMetrics(learnerMetrics);
        this.learnerReportsStore.setLearnerMetricsLoading(false);
      },
      error: () => {
        this.learnerReportsStore.setLearnerMetrics({ rows: [], totalNumberOfItems: 0 });
        this.learnerReportsStore.setLearnerMetricsLoading(false);
      },
    });
  }

  //////////////////////////
  //   Training Reports   //
  //////////////////////////

  getTrainingReport(paramsRequested: any) {
    return this.http.get('Report/training-metrics', {
      params: paramsRequested,
    });
  }

  exportTrainingReport(paramsRequested: any) {
     return this.http.get('Report/training-metrics/export', {
      params: paramsRequested,
    });
  }

  //////////////////////////
  //  Interaction Reports //
  //////////////////////////

  //////////////////////////
  //   Quarterly Reports  //
  //////////////////////////

  getQuarterCourseRegistration(params: any) {
    this.quarterlyReportsStore.setQuarterCourseRegistrationLoading(true);

    return this.http
      .get('Report/course-registration', { params: params })
      .subscribe({
        next: (quarterCourseRegistration: any) => {
          this.quarterlyReportsStore.setQuarterCourseRegistration(quarterCourseRegistration);
          this.quarterlyReportsStore.setQuarterCourseRegistrationLoading(false);
        },
        error: () => this.quarterlyReportsStore.setQuarterCourseRegistrationLoading(false),
      });
  }

  getTotalCourseRegistration(params: any) {
    this.quarterlyReportsStore.setTotalCourseRegistrationLoading(true);

    return this.http.get('Report/course-registration', { params: params }).subscribe({
      next: (totalCourseRegistration: any) => {
        this.quarterlyReportsStore.setTotalCourseRegistration(totalCourseRegistration);
        this.quarterlyReportsStore.setTotalCourseRegistrationLoading(false);
      },
      error: () => this.quarterlyReportsStore.setTotalCourseRegistrationLoading(false),
    });
  }

  getQuarterCourseCertificate(params: any) {
    this.quarterlyReportsStore.setQuarterCourseCertificateLoading(true);

    return this.http.get('Report/course-certificate', { params: params }).subscribe({
      next: (quarterCourseCertificate: any) => {
        this.quarterlyReportsStore.setQuarterCourseCertificate(quarterCourseCertificate);
        this.quarterlyReportsStore.setQuarterCourseCertificateLoading(false);
      },
      error: () => this.quarterlyReportsStore.setQuarterCourseCertificateLoading(false),
    });
  }

  getTotalCourseCertificate(params: any) {
    this.quarterlyReportsStore.setTotalCourseCertificateLoading(true);

    return this.http.get('Report/course-certificate', { params: params }).subscribe({
      next: (totalCourseCertificate: any) => {
        this.quarterlyReportsStore.setTotalCourseCertificate(totalCourseCertificate);
        this.quarterlyReportsStore.setTotalCourseCertificateLoading(false);
      },
      error: () => this.quarterlyReportsStore.setTotalCourseCertificateLoading(false),
    });
  }

  getTopOrganizations(params: any) {
    this.quarterlyReportsStore.setTopOrganizationsLoading(true);

    return this.http.get('Report/top-orgs', { params: params }).subscribe({
      next: (topOrganizations: any) => {
        this.quarterlyReportsStore.setTopOrganizations(topOrganizations);
        this.quarterlyReportsStore.setTopOrganizationsLoading(false);
      },
      error: () => this.quarterlyReportsStore.setTopOrganizationsLoading(false),
    });
  }

  getTopDomains(params: any) {
    this.quarterlyReportsStore.setTopDomainsLoading(true);

    return this.http.get('Report/top-domains', { params: params }).subscribe({
      next: (topDomains: any) => {
        this.quarterlyReportsStore.setTopDomains(topDomains);
        this.quarterlyReportsStore.setTopDomainsLoading(false);
      },
      error: () => this.quarterlyReportsStore.setTopDomainsLoading(false),
    });
  }

  getAccountMetrics(params: any) {
    this.quarterlyReportsStore.setAccountMetricsLoading(true);

    return this.http.get('Report/account-metrics', { params: params }).subscribe({
      next: (accountMetrics: any) => {
        this.quarterlyReportsStore.setAccountMetrics(accountMetrics);
        this.quarterlyReportsStore.setAccountMetricsLoading(false);
      },
      error: () => this.quarterlyReportsStore.setAccountMetricsLoading(false),
    });
  }

  getWebsiteAnalytics(params: any) {
    this.quarterlyReportsStore.setWebsiteAnalyticsLoading(true);

    return this.http.get('Report/website-analytics', { params: params }).subscribe({
      next: (websiteAnalytics: any) => {
        this.quarterlyReportsStore.setWebsiteAnalytics(websiteAnalytics);
        this.quarterlyReportsStore.setWebsiteAnalyticsLoading(false);
      },
      error: () => this.quarterlyReportsStore.setWebsiteAnalyticsLoading(false),
    });
  }

  downloadQuarterlyReport(requestedParams: any) {
    return new Promise((resolve) => {
      this.http.get('report/quarterly/export', {params: requestedParams, responseType: 'blob' as 'json', observe: 'response' }).subscribe({
        next: (res: any) => {
          const fileName = res.headers.get('content-disposition')?.split('filename=')[1].split(';')[0].replaceAll("\"", "");
          const contentType = res.body.type;
          const blob = new Blob([res.body], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
          resolve(true);
        },
        error: (err) => {
          resolve(false);
        },
      });
    });
  }


}
